const initScrollTopButton = () => {
  const goTop = document.getElementById('go-top');

  if (null === goTop) {
    return;
  }

  window.addEventListener('scroll', () => {
    const currentScroll = document.scrollingElement.scrollTop;

    if (currentScroll > 200) {
      goTop.classList.add('shown');
    } else {
      goTop.classList.remove('shown');
    }
  });

  goTop.addEventListener('click', (event) => {
    event.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });
};

export default initScrollTopButton;
